import CommunityPage from "../components/community/CommunityPage";

function Community() {
  return <CommunityPage />;
}
export default Community;
